/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ControlEntityDataleaksResultEvidence } from './ControlEntityDataleaksResultEvidence';
import {
    ControlEntityDataleaksResultEvidenceFromJSON,
    ControlEntityDataleaksResultEvidenceFromJSONTyped,
    ControlEntityDataleaksResultEvidenceToJSON,
} from './ControlEntityDataleaksResultEvidence';

/**
 * 
 * @export
 * @interface ControlEntityDataleaksStandardResult
 */
export interface ControlEntityDataleaksStandardResult {
    /**
     * 
     * @type {string}
     * @memberof ControlEntityDataleaksStandardResult
     */
    user?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlEntityDataleaksStandardResult
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlEntityDataleaksStandardResult
     */
    domain?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlEntityDataleaksStandardResult
     */
    source_asset?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlEntityDataleaksStandardResult
     */
    fullname?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ControlEntityDataleaksStandardResult
     */
    features?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof ControlEntityDataleaksStandardResult
     */
    year?: number;
    /**
     * 
     * @type {string}
     * @memberof ControlEntityDataleaksStandardResult
     */
    date?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlEntityDataleaksStandardResult
     */
    severity?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlEntityDataleaksStandardResult
     */
    target_hostname?: string;
    /**
     * 
     * @type {ControlEntityDataleaksResultEvidence}
     * @memberof ControlEntityDataleaksStandardResult
     */
    evidences?: ControlEntityDataleaksResultEvidence;
    /**
     * 
     * @type {string}
     * @memberof ControlEntityDataleaksStandardResult
     */
    updated?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlEntityDataleaksStandardResult
     */
    created?: string;
}

/**
 * Check if a given object implements the ControlEntityDataleaksStandardResult interface.
 */
export function instanceOfControlEntityDataleaksStandardResult(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ControlEntityDataleaksStandardResultFromJSON(json: any): ControlEntityDataleaksStandardResult {
    return ControlEntityDataleaksStandardResultFromJSONTyped(json, false);
}

export function ControlEntityDataleaksStandardResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlEntityDataleaksStandardResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'user': !exists(json, 'user') ? undefined : json['user'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'domain': !exists(json, 'domain') ? undefined : json['domain'],
        'source_asset': !exists(json, 'source_asset') ? undefined : json['source_asset'],
        'fullname': !exists(json, 'fullname') ? undefined : json['fullname'],
        'features': !exists(json, 'features') ? undefined : json['features'],
        'year': !exists(json, 'year') ? undefined : json['year'],
        'date': !exists(json, 'date') ? undefined : json['date'],
        'severity': !exists(json, 'severity') ? undefined : json['severity'],
        'target_hostname': !exists(json, 'target_hostname') ? undefined : json['target_hostname'],
        'evidences': !exists(json, 'evidences') ? undefined : ControlEntityDataleaksResultEvidenceFromJSON(json['evidences']),
        'updated': !exists(json, 'updated') ? undefined : json['updated'],
        'created': !exists(json, 'created') ? undefined : json['created'],
    };
}

export function ControlEntityDataleaksStandardResultToJSON(value?: ControlEntityDataleaksStandardResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'user': value.user,
        'name': value.name,
        'domain': value.domain,
        'source_asset': value.source_asset,
        'fullname': value.fullname,
        'features': value.features,
        'year': value.year,
        'date': value.date,
        'severity': value.severity,
        'target_hostname': value.target_hostname,
        'evidences': ControlEntityDataleaksResultEvidenceToJSON(value.evidences),
        'updated': value.updated,
        'created': value.created,
    };
}

